import React from 'react';
import { StarIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function TestimonialsSection() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = 'https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1';
  };
  const testimonials = [{
    name: 'Mariana G.',
    text: 'Intenté aprender crochet mil veces y siempre terminaba frustrada… hasta que encontré este ebook. La forma en la que explica es súper clara, paso a paso. En pocos días ya estaba haciendo mis primeros amigurumis sin estrés. Hoy no solo disfruto tejer, ¡sino que me siento orgullosa de lo que hago!',
    rating: 5
  }, {
    name: 'Laura M.',
    text: 'Lo que más me sorprendió fue lo fácil que es seguir los patrones. Antes me perdía todo el tiempo, ahora entiendo cada paso y avanzo sin dudas. Es la primera vez que termino proyectos y me quedan lindos de verdad.',
    rating: 5
  }, {
    name: 'Carla R.',
    text: 'Compré el ebook sin muchas expectativas… pero me cambió totalmente la forma de tejer. Pasé de no saber por dónde empezar, a crear amigurumis que ahora hasta estoy vendiendo. De verdad vale cada peso.',
    rating: 5
  }, {
    name: 'Sofía L.',
    text: "Siempre veía cosas hermosas en Pinterest y pensaba 'yo no puedo hacer eso'. Con este ebook me di cuenta de que sí podía, solo necesitaba una buena guía. Hoy ya hice varios muñequitos y todos me preguntan dónde los compré.",
    rating: 5
  }, {
    name: 'Valentina P.',
    text: 'Me encanta porque no es solo aprender crochet… también te abre la cabeza a que podés generar ingresos con esto. Ya vendí mis primeros amigurumis y no lo puedo creer. Si estás dudando, te diría que lo compres sin pensarlo.',
    rating: 5
  }];
  return <section className="w-full py-24 px-4 bg-secondary/30" data-id="element-179">
      <div className="max-w-6xl mx-auto" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-textDark mb-6" data-id="element-182">
            ⭐ Más de 3.700 tejedoras ya están aprendiendo
          </h2>
          <p className="font-body text-xl text-textLight italic" data-id="element-183">
            Lee lo que dicen nuestras alumnas:
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 mb-20" data-id="element-184">
          {testimonials.map((testimonial, index) => <div key={index} className="break-inside-avoid bg-white rounded-3xl p-8 shadow-soft border border-secondary/50 hover:shadow-soft-lg transition-shadow" data-id="element-185">
              {/* Stars */}
              <div className="flex gap-1 mb-6" data-id="element-186">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" aria-hidden="true" data-id="element-187" />)}
              </div>

              {/* Testimonial Text */}
              <p className="font-body text-textDark text-lg leading-relaxed mb-6 italic" data-id="element-188">
                "{testimonial.text}"
              </p>

              {/* Name */}
              <div className="flex items-center gap-4" data-id="element-189">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-heading font-bold text-xl" data-id="element-190">
                  {testimonial.name.charAt(0)}
                </div>
                <p className="font-heading font-bold text-textDark text-lg" data-id="element-191">
                  {testimonial.name}
                </p>
              </div>
            </div>)}
        </div>

        {/* Final CTA */}
        <div className="text-center" data-id="element-192">
          <a href="https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1" onClick={handleCTAClick} className="inline-block w-full sm:w-auto bg-primary hover:bg-primary/90 text-white font-body font-bold text-xl px-14 py-6 rounded-full shadow-soft-lg transition-all duration-300 transform hover:-translate-y-1" data-id="element-193">
            QUIERO EMPEZAR AHORA
          </a>
        </div>
      </div>
    </section>;
}